import { Component, OnInit,ChangeDetectorRef } from "@angular/core";
import { SharedFormService } from "src/app/shared-utility/services/shared-form.service";

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent implements OnInit {
  isLoading = false;
    
    constructor(private formSvc: SharedFormService, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.formSvc.hideLoader.subscribe((resp) => 
      {
        this.isLoading = resp
        this.cdr.detectChanges();
      })
  }
}
